export default __webpack_public_path__ + "static/media/close.83bfb3b1.svg";